/** Bytes helper for log file rows and preview header. */
export function formatLogBytes(n?: number): string {
    if (!n || n <= 0) return '-';
    const units = ['B', 'KB', 'MB', 'GB'];
    let v = n;
    let i = 0;
    while (v >= 1024 && i < units.length - 1) {
        v = v / 1024;
        i++;
    }
    const dp = i === 0 ? 0 : i === 1 ? 1 : 2;
    return `${v.toFixed(dp)} ${units[i]}`;
}

/** Last path segment from an S3 key for display. */
export function getLogFileName(key: string): string {
    const k = (key || '').trim();
    if (!k) return '';
    return k.split('/').pop() || k;
}

export function getLogFolderFromKey(key: string): string {
    const parts = String(key || '').split('/').filter(Boolean);
    if (parts.length >= 4 && (parts[1] === 'race' || parts[1] === 'debug')) {
        return parts[2] || '';
    }
    return '';
}
